import { useEffect } from 'react';
import { useGetUserSettingsQuery } from 'lib.store/src/main/user-settings/user-settings.api';
import { UserPreferences } from 'lib.shared/src/user-preferences/UserPreferences';

/**
 * Syncs user settings from backend to UserPreferences (localStorage).
 * Runs on mount and whenever backend data changes (e.g. after save + cache invalidation).
 */
export function useUserSettingsSync(isAuthenticated: boolean) {
  const { data: settingsRes } = useGetUserSettingsQuery(undefined, {
    skip: !isAuthenticated,
  });

  useEffect(() => {
    if (!settingsRes?.data) return;
    const prev = UserPreferences.getAll();

    UserPreferences.setAll({
      regional: settingsRes.data.regional,
      ai: settingsRes.data.ai ?? prev.ai,
    });
  }, [settingsRes?.data]);
}
